import { RecipientSetInfo } from './recipient-set-info.model';
import { VaultingInfo } from './vaulting-info.model';
import { MergeFieldInfo } from './merge-field-info.model';
import { FileInfo } from './file-info.model';
import { ExternalId } from './external-id.model';

export class DocumentCreationInfo {
  callbackInfo: string;
  ccs: string[];
  daysUntilSigningDeadline: number;
  externalId: ExternalId;
  fileInfos: FileInfo[];
  mergeFieldInfo: MergeFieldInfo[];
  message: string;
  name: string;
  recipientSetInfos: RecipientSetInfo[];
  reminderFrequency: string;
  signatureFlow: string;
  signatureType: string;
  vaultingInfo: VaultingInfo;

  constructor(info?: any) {
    info = info || {};
    this.callbackInfo = info.callbackInfo || null;
    this.ccs = info.ccs && info.ccs.length > 0 ? info.ccs : [];
    this.daysUntilSigningDeadline = info.daysUntilSigningDeadline || null;
    this.externalId = info.externalId ? new ExternalId(info.externalId) : null;
    this.fileInfos =
      info.fileInfos && info.fileInfos.length > 0
        ? info.fileInfos.map((fileInfo: FileInfo) => new FileInfo(fileInfo))
        : [];
    this.mergeFieldInfo =
      info.mergeFieldInfo && info.mergeFieldInfo.length > 0
        ? info.mergeFieldInfo.map(
            (fieldInfo: MergeFieldInfo) => new MergeFieldInfo(fieldInfo)
          )
        : [];
    this.message = info.message || null;
    this.name = info.name || null;
    this.recipientSetInfos =
      info.recipientSetInfos && info.recipientSetInfos.length > 0
        ? info.recipientSetInfos.map(
            (recSetInfo: RecipientSetInfo) => new RecipientSetInfo(recSetInfo)
          )
        : [];
    this.reminderFrequency = info.reminderFrequency || null;
    this.signatureFlow = info.signatureFlow || null;
    this.signatureType = info.signatureType || null;
    this.vaultingInfo = info.vaultingInfo
      ? new VaultingInfo(info.vaultingInfo)
      : null;
  }
}
